export enum ImageShapeType {
  Circle = 1,
  Rectangle = 2,
}
